import { isDefined } from '@eih-netbroker/common';
import { ReactNode } from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';
import { cssWhen } from '../../utils/themeUtils';
import { NbIconButton } from '../icon-button/IconButton';
import classes from './ModalHeader.module.scss';

export interface ModalHeaderProps {
  title: string | ReactNode;
  onClose: () => void;
  className?: string;
  isSmall?: boolean;
  isWithDivider?: boolean;
  hideCloseButton?: boolean;
}

export const ModalHeader = ({
  title,
  onClose,
  className,
  isSmall,
  isWithDivider,
  hideCloseButton,
}: ModalHeaderProps) => {
  return (
    <div
      className={cssWhen(
        classes.modalHeader,
        [isDefined(className), className!],
        [isSmall, classes.modalHeaderIsSmall],
        [isWithDivider, classes.modalHeaderIsWithDivider],
      )}
    >
      <h4>{title}</h4>
      {!hideCloseButton && (
        <NbIconButton
          icon={<CloseIcon />}
          onClick={onClose}
        />
      )}
    </div>
  );
};
